import React from 'react';

export default function ParentDistributor({ demo, supportUrl }) {
    const parent = demo.parent_distributor;

    return (
        <div className="demo-edit-parent demo-island-text-wrap border-top py-2 text-center small" data-testid="demo-edit-parent">
            {parent
                ? <>
                    <strong>{__('Your distributor')}</strong>
                    {': '}
                    <span>{parent.name}</span>
                    {' '}
                    <a href={`mailto:${parent.email}`}>{parent.email}</a>
                    {' '}
                    <a href={`tel:${parent.phone}`}>{parent.phone}</a>
                </>
                : <a href={supportUrl}>{__('Contact support')}</a>
            }
        </div>
    );
}
